import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { addCard, getCards, deleteCard } from '../../actions/payment';
import BootstrapTable from 'react-bootstrap-table-next';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import './payment.css';
import ViewPayment from './viewPayment';




const { SearchBar } = Search;
const tableHeaderColumnData = [
  {
    dataField: 'credit_card', text: 'Credit Card', sort: true, formatter: (cell, row) => {
      return (
        <span className="m-topbar__userpic">
          <img src="../../../assets/app/media/img/payment/visa.png" className="m-width-50 mr-2" alt="" />
          {cell}
        </span>
      )
    }
  },
  {
    dataField: 'name_on_card', text: 'Name on card', sort: false
  },
  {
    dataField: 'expires_on', text: 'Expires on', sort: false
  },
  {
    dataField: 'actions', text: 'Actions', sort: false, formatter: (cell, row) => {
      return (
        <span>
          <button className="btn m-btn--pill  btn-danger btn-sm px-3 py-1 mx-2 my-2" onClick={(e) => cell()}>Delete</button>
          {cell}
        </span>
      )
    }
  },
  {
    dataField: 'default', text: 'Default', sort: false, formatter: (cell, row) => {
      return (
        <span>
          <label className="m-radio">
            <input type="radio" name="dafault" value="" />Make this Default
              <span></span>
          </label>
          {cell}
        </span>
      )
    }
  },
];
const contentData = [{ credit_card: 'Visa ending in 0017', name_on_card: '45435', expires_on: 'sfdsfsd', actions: function (id) {  } }];


const tableHistoryHeaderColumnData = [
  {
    dataField: 'payment_date', text: 'Payment Date', sort: true
  },
  {
    dataField: 'ir_id', text: 'Invoice/Receipt ID', sort: true
  },
  {
    dataField: 'payment_instrument', text: 'Payment Instrument', sort: true
  },
  {
    dataField: 'transaction_type', text: 'Transaction Type', sort: true
  },
  {
    dataField: 'payment_method', text: 'Payment Method', sort: true
  },
  {
    dataField: 'transaction_amount', text: 'Transaction Amount', sort: true
  },
];
const contentHistoryData = [{ payment_date: '2018-11-03', ir_id: '45435', payment_instrument: 'sfdsfsd' }];

class Payment extends Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    this.props.getCards();
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.cards !== this.props.cards) {
      const actions = function (id) {
          this.props.deleteCard(id);
        }
      let cd = nextProps.cards.push(actions);
      this.setState({ contentData: cd });
    }
  }
  render() {
    return (
      <div className="m-grid m-grid--hor m-grid--root m-page">
        <div className="m-grid__item m-grid__item--fluid m-grid m-grid--hor-desktop m-grid--desktop m-body body-background">
          <div className="m-grid__item m-grid__item--fluid  m-grid m-grid--ver	m-container m-container--responsive m-container--xxl m-page__container">
            <div className="m-grid__item m-grid__item--fluid m-wrapper">
              <div className="m-portlet m-portlet--mobile">
                <div className="m-portlet__head">
                  <div className="m-portlet__head-caption">
                    <div className="m-portlet__head-title">
                      <h3 className="m-portlet__head-text">
                        Payment methods
                        <small>
                          To view your billing address, click edit on your default payment method.
                        </small>
                      </h3>
                    </div>
                  </div>
                </div>
                <div className="m-portlet__body">
                  <div className="m-content">
                    <div className="row">
                      <div className="col-xl-12" id="payment">
                        <ToolkitProvider
                          keyField="id"
                          data={contentData}
                          columns={tableHeaderColumnData}
                          defaultSortDirection="asc"
                          hover={true}
                        // pagination={ paginationFactory() } 
                        // filter={ filterFactory() }
                        >
                          {
                            props => (
                              <div>
                                <div className="payment-btn px-0 mb-4" style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                  <span>
                                    <button className="btn m-btn--pill  btn-success btn-sm mr-2 px-3 py-1" data-toggle="modal" data-target="#add_payment_modal">Add</button>
                                  </span>
                                </div>
                                <BootstrapTable
                                  classes="petTable"
                                  {...props.baseProps}
                                />
                              </div>
                            )
                          }
                        </ToolkitProvider>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="m-portlet__head">
                  <div className="m-portlet__head-caption">
                    <div className="m-portlet__head-title">
                      <h3 className="m-portlet__head-text">
                        Payment History
                    <small>
                          Listed below are the successful payment transactions.
                    </small>
                      </h3>
                    </div>
                  </div>
                </div>
                <div className="m-portlet__body">
                  <div className="m-content">
                    <div className="row">
                      <div className="col-xl-12" id="payment">
                        <ToolkitProvider
                          keyField="id"
                          data={contentHistoryData}
                          columns={tableHistoryHeaderColumnData}
                          defaultSortDirection="asc"
                          hover={true}
                        // pagination={ paginationFactory() } 
                        // filter={ filterFactory() }
                        >
                          {
                            props => (
                              <div>
                                <div className="payment-btn px-0 mb-4" style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                  <span>
                                    <button className="btn m-btn--pill  btn-success btn-sm px-3 py-1 mr-2"><i className="fas fa-download px-2"></i>Download CSV</button>
                                    <button className="btn m-btn--pill  btn-success btn-sm px-3 py-1"><i className="fas fa-print px-2"></i>Print</button>
                                  </span>
                                </div>
                                <div className='px-0 mb-4 search-bar'>
                                  <div className='col-lg-3 px-0 inner-addon right-addon'>
                                    <i className="fas fa-search"></i>
                                    <SearchBar {...props.searchProps} />
                                  </div>
                                </div>
                                <BootstrapTable
                                  classes="petTable"
                                  {...props.baseProps}
                                />
                              </div>
                            )
                          }
                        </ToolkitProvider>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="modal fade" id="add_payment_modal" tabIndex="-1" role="dialog" aria-labelledby="RejectModalLabel" aria-hidden="true">
                <div className="modal-dialog" role="document">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title" id="exampleModalLabel">Add Card</h5>
                      <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div className="modal-body">
                      <div className="row">
                        <div className="col-xl-12">
                          {/* <div className="card card-shadow mb-4">
                                    <div className="card-header border-0">                       
                                      <div className="card-body">
                                      <div className="col-xl-12 p-0">
                                        <span className="m-topbar__userpic">
                                          <img src="../../../assets/app/media/img/payment/sample_cards.jpg" alt="" />
                                        </span>
                                      </div>
                                      <form>
                                        <div className="col-xl-12 p-0">
                                          <div className="form-group">
                                            <label for="card-number" className="form-control-label">Card Number</label>
                                            <input type="text" className="form-control" id="date-of-create" placeholder="4242 0000 4321 9876"/>
                                          </div>
                                        </div>
                                        <div className="row">
                                          <div className="col-xl-6 col-sm-12">
                                            <div className="form-group">
                                              <label for="expiration-date" className="form-control-label">Expiration Date</label>
                                              <input type="text" className="form-control" id="expiration-date" placeholder="04 / 20"/>
                                            </div>
                                          </div>
                                          <div className="col-xl-6 col-sm-12">
                                            <div className="form-group">
                                              <label for="security-code" className="form-control-label">Security Code</label>
                                              <input type="text" className="form-control" id="security-code" placeholder="123"/>
                                            </div>
                                          </div>
                                        </div>
                                        <button className="btn m-btn--pill  btn-success btn-sm px-3 py-1 my-4 float-right">Add Card</button>
                                      </form>
                                      </div>
                                    </div>
                                </div> */}
                          <ViewPayment />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
  deleteCard(id) {

  }
}

const mapStateToProps = state => ({
  user: state.cognito.user,
  cards: state.paymentReducer.cards,
});
const mapDispatchToProps = dispatch => ({
  addCard: (card) => {
    dispatch(addCard(card));
  },
  getCards: () => {
    dispatch(getCards());
  },
  deleteCard: (id) => {
    dispatch(deleteCard(id));
  }
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Payment));